import {IContentMapper} from "../base.content";
import {
  TransferContent,
  TransfersContentDTO,
  TransfersContentRowDTO,
  TransfersContentCellDTO,
  TransfersContentClubCellDTO
} from "../transfers.content";
import { TwoColumnContentDTO } from "../two-column.content";
import {cmsTypeToString} from "../../constants";

export class TransfersContentMapper implements IContentMapper {
  toDTO(data: TransferContent): TransfersContentDTO {
    return {
      type: cmsTypeToString(data.type),
      rightLabel: data.rightLabel,
      leftLabel: data.leftLabel,
      items: data.items.toArray().map((item) : TransfersContentRowDTO => ({
        type: cmsTypeToString(data.type),
        rightCell: { ...item.rightCell, } as TransfersContentClubCellDTO,
        leftCell: { ...item.leftCell } as TransfersContentCellDTO,
      }))
    };

  }

  fromDTO(data: TwoColumnContentDTO): TransferContent {
    let content = new TransferContent({
      leftLabel: data.leftLabel,
      rightLabel: data.rightLabel
    });
    data.items.map(rowData => {
      content = content.addRow(rowData);
    });
    return content;
   };
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/mappers/transfers.ts